import maturitiesAssetsFactory from '../screens/maturities-assets/maturities-assets-factory';

const MATURITIES_ASSETS = [
  'limit',
  'bonds',
  'shares',
  'futures',
  'funds',
  'swaps',
  'commodities',
  'options',
  'structuredProducts',
  'insurancePolicies',
  'cash',
  'others',
  'pawn',
  'property',
  'mmDeposites',
  'credit'
];

const routeConfig = {};

MATURITIES_ASSETS.map(assetId => {
  const Component = maturitiesAssetsFactory({
    assetCategory: assetId,
  });

  routeConfig[`/maturities/${assetId}`] = {
    component: Component,
    maturitiesAssetsTitle: assetId,
  };
});

export default routeConfig;